<h1 class="mb-2">
    <mdb-icon fas icon="tasks"></mdb-icon> Productos
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
        <p class="mb-0">
            <span class="grey-text">Maestros</span>
            <span> / </span>
            <span>Productos</span>
        </p>
    </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
        <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6;">
            <div></div>
            <button type="button" mdbBtn color="info" (click)="showModalAgregarDtoProducto()" size="sm" mdbWavesEffect>
                Agregar
            </button>
        </div>
        <div class="row filtros-body">
            <div [ngClass]="{'col': true, disabledContent: filtersDisabled}" style="max-width: 200px;">
                <div class="md-form">
                    <input value="" type="text" id="sku" class="form-control" [(ngModel)]="filtroSku" placeholder="001"
                        #sku />
                    <label for="sku">
                        SKU
                    </label>
                </div>
            </div>

            <div [ngClass]="{'col': true, disabledContent: filtersDisabled}" style="max-width: 300px;">
                <div class="md-form">
                    <input value="" type="text" id="descripcion" class="form-control" [(ngModel)]="filtroDescipcion"
                        placeholder="Descripción" #descripcion />
                    <label for="descripcion">Descripción</label>
                </div>
            </div>

            <div [ngClass]="{'col': true, disabledContent: filtersDisabled}" style="max-width: 320px;">
                <div class="md-form">
                    <mdb-select label="Familia" [multiple]="true" [options]="optionsFamilia" [(ngModel)]="filtrofamilia"
                        placeholder="Familia" [filterEnabled]="true">
                    </mdb-select>
                </div>
            </div>

            <!-- <div [ngClass]="{'col': true, disabledContent: filtersDisabled}" style="max-width: 200px;">
                <div class="md-form" style="margin-bottom: 0">
                    <mdb-checkbox [(ngModel)]="filtroActivo">
                        <span style="font-size: 1rem">Activos</span>
                    </mdb-checkbox>
                </div>
            </div>

            <div class="col" style="max-width: 200px;">
                <div class="md-form" style="margin-bottom: 0">
                    <mdb-checkbox (change)="handleCheckTodos($event)">
                        <span style="font-size: 1rem">Todos</span>
                    </mdb-checkbox>
                </div>
            </div> -->
        </div>


        <div class="row filtros-body">
            <div class="col d-flex">
                <!-- Material inline 1 -->
                <div class="form-check form-check-inline">
                    <input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
                        [(ngModel)]="busquedaEstado" [value]="1" checked mdbInput />
                    <label class="form-check-label" for="materialInline1">Activos</label>
                </div>

                <!-- Material inline 2 -->
                <div class="form-check form-check-inline">
                    <input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
                        [(ngModel)]="busquedaEstado" [value]="2" mdbInput />
                    <label class="form-check-label" for="materialInline2">Inactivos</label>
                </div>

                <div class="form-check form-check-inline">
                    <input type="radio" class="form-check-input" id="materialInline3" name="inlineMaterialRadiosExample"
                        [(ngModel)]="busquedaEstado" [value]="3" mdbInput />
                    <label class="form-check-label" for="materialInline3">Todos</label>
                </div>
            </div>
        </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
        <div></div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
            <mdb-icon fas icon="search"></mdb-icon>
            Buscar
        </button>
    </div>
</div>

<section *ngIf="showButton" style="z-index: 2;">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 2;top: 25%;">
    <div class="example-flex-container" style="z-index: 2;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page" (click)="onScrollTop()">
          <mat-icon class="icon_ArrowUp">arrow_upward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
<section style="z-index: 3;" *ngIf="showButtonDown">
  <div class="example-button-row" style="position:fixed; right: 0px; z-index: 3;">
    <div class="example-flex-container" style="z-index: 3;">
      <div class="example-button-container">
        <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page" (click)="onScrollAbajo()">
          <mat-icon class="icon_ArrowUp">arrow_downward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>

<!-- Listado -->
<section infinite-scroll (scrolled)="onScrollDown($event)" style="z-index: 1;">
    <div class="card mb-2 wow" *ngIf="listOfProducts" style="z-index: 1;width: 125%;">
        <div class="card-body">
            <div class="">

                <table class="table table-striped table-hover table-sm align-middle"
                  mdbTableEditor
                  mdbTable
                  mdbTableScroll scrollX="true" scrolly="true"
                  maxHeight="500" striped="true" bordered="true"
                  stickyHeaderBgColor="#E0E0E0"
                  stickyHeaderTextColor="#212529"
                  stickyHeader="true">
                    <thead class="grey lighten-2">
                        <tr>
                            <th scope="col" class="text-center" style="width: 20px;">Resumen</th>
                            <th scope="col" class="text-center" style="width: 100px;">SKU</th>
                            <th scope="col" class="text-center" style="width: 300px;">Descripión</th>
                            <th scope="col" class="text-center" style="width: 100px;">Estado</th>
                            <th scope="col" class="text-center" style="width: 120px;">Datos del producto</th>
                            <th scope="col" class="text-center" style="width: 120px;">Datos comerciales</th>
                            <th scope="col" class="text-center" style="width: 120px;">Stock Producto</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="listOfProducts?.length === 0">
                        <td colspan="100%" style="text-align: center">
                          No se encontró información
                        </td>
                      </tr>
                        <tr *ngFor="let producto of listOfProducts">
                            <td class="text-center">
                                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                                    (click)="loadAndShowResumen(producto)" mdbTooltip="Ver" placement="right">
                                    <mdb-icon fas icon="eye"></mdb-icon>
                                </button>
                            </td>
                            <td (click)="loadAndShowResumen(producto)">{{ producto.sku }}</td>
                            <td (click)="loadAndShowResumen(producto)">{{ producto.descripcion }}</td>
                            <td (click)="loadAndShowResumen(producto)" class="text-center">
                                <div *ngIf="producto.activo">
                                    <mdb-badge pill="true" success="true">Activo</mdb-badge>
                                </div>
                                <div *ngIf="!producto.activo">
                                    <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
                                </div>
                            </td>
                            <td class="text-center">
                                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                                    (click)="loadAndShowProducto(producto)" mdbTooltip="Editar" placement="right">
                                    <mdb-icon fas icon="pen"></mdb-icon>
                                </button>
                            </td>
                            <td class="text-center">
                                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                                    (click)="loadAndShowDatosComerciales(producto);" mdbTooltip="Editar" placement="right">
                                    <mdb-icon fas icon="pen"></mdb-icon>
                                </button>
                            </td>
                            <td class="text-center">
                                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                                    (click)="showModalStock(producto);" mdbTooltip="Editar" placement="right">
                                    <mdb-icon fas icon="pen"></mdb-icon>
                                </button>
                            </td>
                        </tr>
                        <tr>
                          <td colspan="100%" style="text-align: center">
                            <div class="row pb-1 pt-1" id="spinnerX">
                              <div class="col-md-12 p-4">
                                <ngx-spinner
                                bdColor=""
                                bdoOpacity="0.9"
                                size="default"
                                color="#581f87"
                                type="ball-pulse-sync"
                                [fullScreen]="false"
                                >
                              </ngx-spinner>

                              </div>
                           </div>
                          </td>

                        </tr>
                    </tbody>
                    <!-- <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                        *ngIf="listaProducto?.length > 0"></app-pagination> -->
                        <tfoot *ngIf="listOfProducts?.length > 0">
                          <tr>
                            <!-- Página {{ paginaActual }} de  {{ totalPaginas }} -->
                            <th colspan="12">
                              {{ PagPosActual }} de  {{ totalPagPos }} ({{
                                totalRegistrosPos
                              }}
                              registros)

                            </th>
                          </tr>
                        </tfoot>
               </table>
            </div>
        </div>
    </div>
</section>
<!-- MODAL Agregar producto -->
<app-productos-modal-add (onSuccess)="onAddedOrEditedProduct()"></app-productos-modal-add>

<!-- MODAL Editar producto -->
<app-productos-modal-add-edit (onSuccess)="onAddedOrEditedProduct()"></app-productos-modal-add-edit>

<!-- MODAL resumenProducto -->
<app-productos-modal-resumen></app-productos-modal-resumen>

<!-- MODAL seleccionImpuesto -->
<app-producto-modal-seleccionar-impuesto (onImpuestoSeleccionado)="capturaImpuesto($event)"></app-producto-modal-seleccionar-impuesto>

<!-- MODAL datosComerciales -->
<app-productos-modal-datos-comerciales></app-productos-modal-datos-comerciales>

<!-- MODAL stockProducto -->
<app-modal-stock></app-modal-stock>
